
/**
 * contiene la información para el manejo de productos.
 */
export const defaultFilters = () => {
    return {
        search: '',
        manufacturer_id: null
    };
};

/**
 * contiene la inicial del objeto paginación.
 */
export const defaultPaginate = () => {
    return {
        page: 1,
        per_page: 10,
        total: 10,
        limits: [10, 30, 50, 100]
    };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    filters: defaultFilters(),
    manufacturers: [],
    productSelected: null,
    products: [],
    paginate: defaultPaginate()
};
